export default "__VITE_ASSET__BTEjBXuP__"